
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h2>Partner Accounts</h2>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="table-card">
        <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" [href]="'/#/partner-edit'">Create Partner Account</a></list-controls>
        <table class="table table-responsive">
          <thead>
            <tr class="table-header-with-controls">
              <th>Name</th>
              <th>Email Address</th>
              <th>Organization</th>
              <th>Roles</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let partner of partners">
              <td *ngIf="partner.firstName">{{ partner.lastName }}, {{ partner.firstName }}</td>
              <td *ngIf="!partner.firstName">{{ partner.lastName }}</td>
              <td>{{ partner.emailAddress }}</td>
              <td>{{ partner.organization }}</td>
              <td><span *ngFor="let role of partner.roles; let isLast = last">{{ role }}
                  <ng-template [ngIf]="!isLast"><br></ng-template></span></td>
              <td class="text-right">
                <div class="btn-group"><a class="btn btn-outline-primary btn-sm" *ngIf="partner.registrationLink &amp;&amp; partner.registrationLink.length &gt; 0" href="javascript:void(0)" (click)="displayPartnerRegistrationLinkDialog(partner.id, partner.registrationLink)"><span class="oi oi-link-intact oi-smaller"></span> Registration Link</a><a class="btn btn-outline-primary btn-sm" href="#/partner-edit?id={{partner.id}}"><span class="oi oi-pencil oi-smaller"></span> Edit</a></div>
              </td>
            </tr>
            <tr *ngIf="partners.length === 0">
              <td colspan="6">
                <p class="text-center empty-table-message">There are no partner accounts to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>